import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { Field } from "redux-form";
import { Scrollbars } from "react-custom-scrollbars";
import classNames from "classnames";

import { AttachmentProgress } from "../../../../common/attachments";
import ClientAttachmentFile from "./ClientAttachmentFile";
import { S3FileInput } from "../../../../common/form";
import { RectangleSpinner } from "../../../../common/spinners";

import { CLIENT_ATTACHMENTS } from "../../../../../utils/data/models";
import * as downloaderActions from "../../../../../utils/downloader/downloaderActions";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { buildQueryString } from "../../../../../../utils/url";
import AttachmentsDownloader from "../../../../../utils/downloader/AttachmentsDownloader";
import { getTenantFromURL } from "../../../../common/MultiTenancy/MultiTenancyHelper";
import { getSessionCookies } from "../../../../common/sessions/tokenHelper";
import loginApi from "../../../../login/loginApi";
import store from "../../../../../store.js";
import { isClientArchived } from "../../../../common/RouteValidators/ClientValidationHelper.js";


const ClientAttachments = (props) => {
  const extractQueryParams = (url) => {
    if (!url) {
      return {};
    }

    return (/^[?#]/.test(url) ? url.slice(1) : url)
      .split("&")
      .reduce((params, param) => {
        let [key, value] = param.split("=");
        params[key] = value
          ? decodeURIComponent(value.replace(/\+/g, " "))
          : "";
        return params;
      }, {});
  };

  const { shortLivedURL } = props;
  const renderDownloader = !!shortLivedURL && shortLivedURL != "";

  let url, queryParams;
  if (renderDownloader) {
    url = shortLivedURL.substr(0, shortLivedURL.indexOf("?"));
    queryParams = extractQueryParams(
      shortLivedURL.substr(shortLivedURL.indexOf("?"))
    );
  }

  let s3path = url + buildQueryString(queryParams, url);
  const fileName = s3path.split("/").pop().split("?")[0];

  let downloadData = !!fileName && !!url && !!queryParams;
  let [accessToken] = getSessionCookies();
  accessToken = `JWT ${accessToken}`;
  const tenant = getTenantFromURL();

  const handleError = async (err) => {
    // 400 is returned by API when token is not valid
    if (err.startsWith("Could not contact request signing server. Status = 400")) loginApi.login({ returnSessionError: true });
    if (props.activeClient && props.activeClient.clientId) {
      const isArchived = await isClientArchived(props.activeClient.clientId);
      isArchived && store.dispatch({
        type: "SHOW_TOAST",
        value: "clientArchivedModification",
      });
    }
  };

  const uploaderProps = {
    style: {},
    server: __API_URL__,
    maxFileSize: 1024 * 1024 * 100,
    isImage: () => false,
    progressComponent: AttachmentProgress,
    fileComponent: () => null,
    multiple: false,
    signingUrl: CLIENT_ATTACHMENTS.signingPath,
    signingUrlMethod: "GET",
    signingUrlHeaders: { Authorization: accessToken, Tenant: tenant },
    signingUrlQueryParams: {
      clientMethod: "put_object",
      objectPath: props.clientGuid,
      bucket_type: "CLIENTS",
    },
    uploadRequestHeaders: { "Access-Control-Allow-Origin": "*" },
    contentDisposition: "attachment",
    onFinish: props.handleUploadFinish,
    onError: handleError,
  };

  const list = (showNoFilesMessage) => {
    const listClassNames = classNames({
      "attachment-list": true,
      "not-empty":
        !!props.clientAttachments && props.clientAttachments.length > 0,
    });
    let content = "";

    if (props.clientAttachments == null && !!props.clientId) {
      content = <RectangleSpinner />;
    } else if (
      !!props.clientAttachments &&
      props.clientAttachments.length > 0
    ) {
      content = (
        <Scrollbars
          autoHide={true}
          style={{ height: 150 }}
          renderView={({ ...props }) => (
            <div {...props} className="attachment-scrollarea" />
          )}
        >
          {props.clientAttachments.map((attachment, index) => {
            return (
              <ClientAttachmentFile
                key={index}
                readOnly={props.readOnly}
                handleAttachmentDelete={props.handleAttachmentDelete}
                handleAttachmentDownload={props.handleAttachmentDownload}
                {...{ ...attachment, filePath: props.clientGuid }}
              />
            );
          })}
        </Scrollbars>
      );
    } else if (showNoFilesMessage) {
      content = (
        <p className="empty-attachment-list">
          <FormattedMessage id="attachments.attachmentListEmpty" />
        </p>
      );
    }
    return <div className={listClassNames}>{content}</div>;
  };

  return (
    <div className="attachments">
      <h5>
        <FormattedMessage id="attachments.attachmentLabel" />
      </h5>
      <div className="attachments-zone">
        {!props.readOnly && (
          <div className="uploader">
            <Field
              id="clientAttachmentUploader"
              name="clientAttachmentUploader"
              component={S3FileInput}
              list={list}
              uploaderProps={uploaderProps}
            />
          </div>
        )}
        {props.readOnly && list(true)}
        {renderDownloader && downloadData && (
          <AttachmentsDownloader
            url={url}
            queryParams={queryParams}
            fileName={fileName}
            onDownloaded={props.handleAttachmentDownloaded}
          />
        )}
      </div>
    </div>
  );
};

ClientAttachments.propTypes = {
  activeClient: PropTypes.object,
  clientGuid: PropTypes.string,
  clientId: PropTypes.number,
  clientAttachments: PropTypes.array,
  readOnly: PropTypes.bool,
  shortLivedURL: PropTypes.string,
  handleAttachmentDelete: PropTypes.func,
  handleAttachmentDownload: PropTypes.func,
  handleAttachmentDownloaded: PropTypes.func,
  handleUploadFinish: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => {
  return {
    downloaderActions: bindActionCreators(downloaderActions, dispatch),
  };
};

const mapStateToProps = (state) => {
  const currentDownloads = state.downloader || {};
  const activeClient = state.data.clients && state.data.clients.active;
  return {
    currentDownloads: currentDownloads.files,
    activeClient
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ClientAttachments);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/clientAttachments/ClientAttachment.js